import { render, staticRenderFns } from "./LicenseConfirmationModal.vue?vue&type=template&id=2b5ea7a9&scoped=true"
import script from "./LicenseConfirmationModal.vue?vue&type=script&lang=js"
export * from "./LicenseConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./LicenseConfirmationModal.vue?vue&type=style&index=0&id=2b5ea7a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5ea7a9",
  null
  
)

export default component.exports